import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const whyusblock = [
  {
    id: 1,
    icon: 'home',
    title: 'Buy a new home',
    text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    link: 'listings',
  },
  {
    id: 2,
    icon: 'sales-agent',
    title: 'Sell a home',
    text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    link: 'submit-listing',
  },
  {
    id: 3,
    icon: 'apartment',
    title: 'Rent a home',
    text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    link: 'listings',
  },
];

class Whyus extends Component {
  render() {
    return (
      <div className='section section-padding infographics-3'>
        <div className='container'>
          <div className='section-title-wrap section-header'>
            <h2 className='title'>
              How Can We
              <br /> Help You?
            </h2>
          </div>
          <div className='row'>
            {whyusblock.map((item, i) => (
              <Link to={item.link} key={i} className='col-lg-4'>
                <div >
                  <div className='acr-infographic-item'>
                    <i className={'flaticon-' + item.icon + ''} />
                    <div className='acr-infographic-item-body'>
                      <h5>{item.title}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Whyus;
